import { useEffect } from "react";

export default function Privacy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const last = "April 13, 2026";

  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif", padding: "80px 24px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        h1 { font-family: 'DM Serif Display', serif; font-size: 36px; font-weight: 400; margin-bottom: 8px; }
        h2 { font-size: 16px; font-weight: 500; color: #f0ede8; margin: 32px 0 10px; }
        p { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 12px; }
        ul { padding-left: 20px; margin-bottom: 12px; }
        li { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 4px; }
        a { color: #7B5EA7; text-decoration: none; }
        hr { border: none; border-top: 0.5px solid rgba(255,255,255,0.07); margin: 32px 0; }
      `}</style>

      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <a href="/" style={{ fontSize: 13, color: "rgba(240,237,232,0.4)", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 40 }}>← Back to Creator Protect</a>

        <h1>Privacy Policy</h1>
        <p style={{ fontSize: 13, color: "rgba(240,237,232,0.35)", marginBottom: 40 }}>Last updated: {last}</p>

        <p>Creator Protect ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform at creatorprotect.io.</p>

        <hr />

        <h2>1. Information we collect</h2>
        <p>We collect information you provide directly to us, including:</p>
        <ul>
          <li>Account information — email address, password, creator username</li>
          <li>Billing information — processed securely through Stripe; we do not store card details</li>
          <li>Content you upload — videos and images submitted for fingerprinting and protection</li>
          <li>Platform usernames you provide for monitoring purposes</li>
        </ul>
        <p>We also collect certain information automatically when you use our service, including IP address, browser type, device information, and usage data.</p>

        <h2>2. How we use your information</h2>
        <ul>
          <li>To provide, maintain, and improve our content protection services</li>
          <li>To generate fingerprints and, where available, watermarks for your content</li>
          <li>To monitor platforms for unauthorized distribution of your content</li>
          <li>To file DMCA takedown notices on your behalf</li>
          <li>To process payments and manage your subscription</li>
          <li>To send service-related communications including takedown reports</li>
          <li>To respond to your comments and questions</li>
        </ul>

        <h2>3. DMCA filings and your identity</h2>
        <p>When we file DMCA takedown notices on your behalf, we file them under Creator Protect's legal identity as your authorized agent. Your real name, home address, and personal contact information are not disclosed in any takedown notice unless you explicitly request otherwise or it is required by law.</p>

        <h2>4. Content you upload</h2>
        <p>Videos and images you upload to Creator Protect are used solely for the purpose of generating fingerprints and, where applicable, watermarks for content protection. We do not distribute, sell, or share your content with third parties. Uploaded files are processed and deleted from our servers within 24 hours of processing completion. Fingerprint data — which cannot be used to reconstruct your content — is retained in our database for ongoing monitoring purposes.</p>

        <h2>5. Information sharing</h2>
        <p>We do not sell your personal information. We may share your information with:</p>
        <ul>
          <li>Service providers who assist in operating our platform (Supabase, Render, Vercel, SendGrid, Stripe)</li>
          <li>Law enforcement or legal authorities when required by law</li>
          <li>Platform operators when filing authorized DMCA takedown notices</li>
        </ul>

        <h2>6. Data retention</h2>
        <p>We retain your account information for as long as your account is active. Content fingerprints are retained for ongoing monitoring purposes. You may request deletion of your account and associated data at any time by contacting us at privacy@creatorprotect.io.</p>

        <h2>7. Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. All data is transmitted over encrypted connections (HTTPS). Passwords are hashed and never stored in plain text.</p>

        <h2>8. Your rights</h2>
        <p>Depending on your location, you may have the right to access, correct, or delete your personal information. To exercise these rights, contact us at privacy@creatorprotect.io.</p>

        <h2>9. Cookies</h2>
        <p>We use essential cookies to maintain your login session. We do not use tracking or advertising cookies.</p>

        <h2>10. Changes to this policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by email or by posting a notice on our platform.</p>

        <h2>11. Contact us</h2>
        <p>If you have questions about this Privacy Policy, contact us at <a href="mailto:privacy@creatorprotect.io">privacy@creatorprotect.io</a>.</p>

        <hr />
        <p style={{ fontSize: 12, color: "rgba(240,237,232,0.25)" }}>© 2026 Creator Protect. All rights reserved.</p>
      </div>
    </div>
  );
}
